<template>
  <div class="account-number-widget">
    <div class="limit-progress-container">
      <div class="total-limit-text text-right text-md-left">
        <div class="total-limit-number">
          {{
            (buyer.balance + buyer.product_based_limit)
              | currency(null, null, currencyOptions.fractionCount)
          }}
        </div>
        <div class="total-limit-label">
          {{ $t('buyers.single.buyer.plan.totalLimitLabel') }}
        </div>
      </div>
      <div
        class="limit-progress"
        :class="limitProgressColor"
        :style="`width: ${progressWidth * 100}%`"
      >
        <div :class="limitProgressTextClass" class="d-flex">
          <div class="limit-progress-number">
            {{
              buyer.balance
                | currency(null, null, currencyOptions.fractionCount)
            }}
          </div>
          <div class="limit-progress-label">
            {{ $t('buyers.single.buyer.plan.progressLabel') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currencyOptions: {
        fractionCount: 0
      }
    }
  },
  computed: {
    progressWidth() {
      if (this.buyer.product_based_limit === 0 && this.buyer.balance === 0) {
        return 0
      } else {
        return (
          this.buyer.balance /
          (this.buyer.product_based_limit + this.buyer.balance)
        )
      }
    },
    limitProgressColor() {
      if (this.progressWidth < 0.5) {
        return 'bg-primary'
      } else if (this.progressWidth < 0.75) {
        return 'bg-warning'
      } else {
        return 'bg-danger'
      }
    },
    limitProgressTextClass() {
      return this.progressWidth > 0.5
        ? 'limit-progress-text-left'
        : 'limit-progress-text-right'
    }
  },
  props: ['buyer']
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.limit-progress-container {
  border-radius: $border-radius 0 0 $border-radius;
  background: $gray-200;
  height: 1rem;
  position: relative;
  margin-top: 1rem;
  margin-bottom: 4rem;
}

.total-limit-text,
.limit-progress-text-right,
.limit-progress-text-left {
  position: absolute;
  display: flex;
  color: $gray-600;
  padding-right: 1rem;
  padding-left: 1rem;
}

.limit-progress-text-right,
.limit-progress-text-left {
  padding-top: 1rem;
  top: 0.5rem;
}

.limit-progress-text-right {
  border-left: 1px solid $gray-300;
  margin-right: -100%;
  left: 100%;
}

.limit-progress-text-left {
  right: 0;
  border-right: 1px solid $gray-300;
}

.total-limit-text {
  bottom: 0.5rem;
  right: 0;
  border-right: 1px solid $gray-300;
  padding-right: 1rem;
  padding-bottom: 1rem;
}

.total-limit-number,
.limit-progress-number {
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0 0.6rem;
  letter-spacing: 0.7px;
  color: $dc-input-color;
  text-transform: uppercase;
}

.total-limit-label,
.limit-progress-label {
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
  color: $dc-input-color;
  font-family: $lato;
}

.limit-progress {
  position: relative;
  border-radius: $border-radius 0 0 $border-radius;
  height: 100%;
  width: 50%;
}

@include media-breakpoint-down(sm) {
  .account-number-widget {
    .limit-progress-text-right,
    .total-limit-text,
    .limit-progress-text-left {
      display: flex;
      flex-direction: column;
      .limit-progress-number,
      .total-limit-number {
        font-size: 1.25rem;
        padding: 0;
        white-space: nowrap;
        font-weight: 500;
      }
      .limit-progress-label,
      .total-limit-label {
        white-space: nowrap;
        width: auto;
        padding: 0.25rem 0;
      }
    }
    .limit-progress-text-left {
      padding-top: 1.5rem;
      .limit-progress-number {
        text-align: right;
      }
    }
    .limit-progress-text-right {
      padding-top: 1.5rem;
    }
    .total-limit-text {
      padding-bottom: 1.5rem;
    }
  }
}
</style>
